import React from 'react';
import PropTypes from 'prop-types';

import Colours from '../definitions/Colours';


function Checkmark({
    strokeColour = Colours.LIME,
    strokeWidth = '3',
    ...otherProps
}) {
    return (
        <svg
            viewBox="0 0 24 24"
            {...otherProps}
        >
            <g
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g
                    transform="translate(2.000000, 5.000000)"
                    stroke={strokeColour}
                    strokeWidth={strokeWidth}
                >
                    <polyline points="1.17647059 6.37343984 7.89104723 12 18.8235294 2" />
                </g>
            </g>
        </svg>
    );
}

Checkmark.propTypes = {
    strokeColour: PropTypes.oneOf(Object.values(Colours)),
    strokeWidth: PropTypes.string,
};


export default Checkmark;
